import { render, staticRenderFns } from "./CmsRenderer.vue?vue&type=template&id=2580312a&scoped=true"
import script from "./CmsRenderer.vue?vue&type=script&lang=js"
export * from "./CmsRenderer.vue?vue&type=script&lang=js"
import style0 from "./CmsRenderer.vue?vue&type=style&index=0&id=2580312a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580312a",
  null
  
)

export default component.exports